import styles from './header.module.scss';

import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { authActions } from '@greenkub-fronts/domain/auth';
import {
  AppDispatch,
  RootState,
  UiTheme,
} from '@greenkub-fronts/shared/interface';
import { toggleSideBar } from '@greenkub-fronts/domain/ui';

import { AppearDown, CustomerSearch, Avatar, Icon, IconEnum } from '../..';
import { logo_square } from '../../../assets';

export interface HeaderProps {
  isCrm?: boolean;
  currentTheme?: string;
}

export const Header = (props: HeaderProps) => {
  const { isCrm = true, currentTheme = 'greenkub' } = props;

  const dispatch = useDispatch<AppDispatch>();

  const { user } = useSelector((state: RootState) => state.auth);
  const { sideBarIsOpen } = useSelector((state: RootState) => state.ui);

  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false);

  const onToggleProfileMenu = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  if (!user) return <></>;

  return (
    <header
      className={cx(
        styles['Header'],
        isCrm ? ' isCrm' : '',
        sideBarIsOpen && currentTheme !== UiTheme.GEKA
          ? styles['sidebarIsOpen']
          : styles['sidebarIsClosed']
      )}
    >
      {!isCrm ? (
        <Link className={styles['Header-logo']} to="/">
          {currentTheme === 'geka' ? (
            <Icon name={IconEnum.GEKA_LOGO_GREEN_NO_BG} />
          ) : (
            <img src={logo_square} alt="Logo Greenkub" />
          )}
        </Link>
      ) : (
        <CustomerSearch />
      )}

      <div
        className={styles['Header-profile']}
        onClick={() => onToggleProfileMenu()}
      >
        <div className={styles['Header-profile-infos']}>
          <Avatar user={user} />
          <div className="column">
            <span className={styles['Header-profile-name']}>
              {user.firstName + ' ' + user.lastName}
            </span>
            <span className={styles['Header-profile-email']}>{user.email}</span>
          </div>
        </div>

        <button
          className={`${styles['Header-toggleProfileMenu']} icon-button${
            isMenuOpened === true ? ' active' : ''
          }`}
        >
          <Icon name={IconEnum.ARROW_DROP_DOWN} />
        </button>

        <AppearDown isActive={isMenuOpened} duration=".2s">
          <div
            className={cx(
              styles['Header-profile-menu'],
              isMenuOpened && styles['open']
            )}
          >
            <ul>
              <li>
                <button onClick={() => dispatch(authActions.logout())}>
                  <Icon name={IconEnum.EXIT_TO_APP} />
                  <span>Déconnexion</span>
                </button>
              </li>
            </ul>
          </div>
        </AppearDown>
      </div>

      <button
        className={styles['Header-toggleMenuMobile'] + ' icon-button'}
        onClick={() => dispatch(toggleSideBar())}
      >
        <Icon name={IconEnum.MENU} />
      </button>
    </header>
  );
};

export default Header;
